import {

    Card,
    CardBody,
    CardFooter,
    Image,
} from "@nextui-org/react";
import React, {useEffect} from "react";

import {useLocation, useNavigate} from "react-router-dom";


export function CardComponent({props}) {

    const {pathname} = useLocation();


    let item = props.item;
    let index = props.index;
    let isCape = props.isCape ?? false;
    const navigate = useNavigate();
    useEffect(() => {

    }, []);
    return <div className={'w-full'} key={'card_container_key_' + index} id={'card_container_key_' + index}>
        <Card key={'card_key_' + index} className={'w-full h-48 sm:h-52 md:h-60 lg:h-72'} shadow="sm" isHoverable
              isPressable
              onPress={() => {

                  navigate(`/skins/Details/${item.skin_id}|${isCape}`);
              }}>
            <CardBody
                key={'card_body_key_' + index}
                className="overflow-visible p-0 justify-center align-middle items-center">
                <div className={'flex justify-center items-center'} style={{height: "150", width: "150"}}>
                    <Image
                        className={'skinImage'}
                        src={"https://smtbplemmkboppkjvvhk.supabase.co/storage/v1/object/public/mincraft_data/minecraft_skin/" + item.skin_id + ".png"}
                    />
                </div>

            </CardBody>

        </Card>
    </div>;
}